var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon-list",
    viewBox: "0 0 12.5 9.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "shop page",
    id: "shop_page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5.75a.76.76 0 01-.75.75h-11A.76.76 0 010 .75.76.76 0 01.75 0h11a.76.76 0 01.75.75z",
    fill: "#FFFFFF",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.75a.76.76 0 01-.75.75h-11A.76.76 0 010 4.75.76.76 0 01.75 4h11a.76.76 0 01.75.75z",
    "data-name": "Rectangle",
    fill: "#FFFFFF",
    id: "Rectangle-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.75a.76.76 0 01-.75.75h-11A.76.76 0 010 8.75.76.76 0 01.75 8h11a.76.76 0 01.75.75z",
    "data-name": "Rectangle",
    fill: "#FFFFFF",
    id: "Rectangle-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.3b6b969af7721b699afa2192580bdd8d.svg";
export { ForwardRef as ReactComponent };